import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
  DrawerFooter,
  DrawerClose
} from '../../ui/drawer'
import { Button } from '../../ui/button'
import { Input } from '../../ui/input'
import CoachMultiSelect from './CoachMultiSelect'
import SkillLevelMultiSelect from './SkillLevelMultiSelect'

function CoachingSettingsDrawer({
  open,
  onOpenChange,
  coaches,
  supportedSkillLevels,
  selectedCoaches,
  selectedSkillLevels,
  maxStudents,
  onCoachesChange,
  onSkillLevelsChange,
  onMaxStudentsChange
}) {
  const [localMaxStudents, setLocalMaxStudents] = useState(maxStudents || '')

  useEffect(() => {
    const currentParsed = localMaxStudents === '' ? null : parseInt(localMaxStudents, 10)
    if (currentParsed !== maxStudents) {
      setLocalMaxStudents(maxStudents?.toString() || '')
    }
  }, [maxStudents])

  function handleMaxStudentsChange(e) {
    const { value } = e.target
    setLocalMaxStudents(value)
    onMaxStudentsChange(value === '' ? null : parseInt(value, 10))
  }

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Coaching Settings</DrawerTitle>
          <DrawerDescription>Select coaches, skill levels they can teach, and set class capacity.</DrawerDescription>
        </DrawerHeader>

        <div className="flex-1 p-6 space-y-6 overflow-y-auto">
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900">Who will be coaching this class?</label>
            <CoachMultiSelect coaches={coaches} value={selectedCoaches} onChange={onCoachesChange} />
          </div>

          <div>
            <label className="block mb-2 text-sm font-medium text-gray-900">What levels will they be coaching?</label>
            <SkillLevelMultiSelect
              skillLevels={supportedSkillLevels}
              value={selectedSkillLevels}
              onChange={onSkillLevelsChange}
            />
          </div>

          <div>
            <label htmlFor="max_students" className="block mb-2 text-sm font-medium text-gray-900">
              How many spots are in this class?
            </label>
            <Input
              id="max_students"
              className="w-full"
              type="number"
              min={0}
              placeholder="Leave blank for unlimited spots"
              value={localMaxStudents}
              onChange={handleMaxStudentsChange}
            />
          </div>
        </div>

        <DrawerFooter className="border-t border-gray-200">
          <DrawerClose asChild>
            <Button variant="outline" className="w-full">
              Done
            </Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}

CoachingSettingsDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  coaches: PropTypes.array.isRequired,
  supportedSkillLevels: PropTypes.array.isRequired,
  selectedCoaches: PropTypes.array.isRequired,
  selectedSkillLevels: PropTypes.array.isRequired,
  maxStudents: PropTypes.number,
  onCoachesChange: PropTypes.func.isRequired,
  onSkillLevelsChange: PropTypes.func.isRequired,
  onMaxStudentsChange: PropTypes.func.isRequired,
  facilityId: PropTypes.string.isRequired
}

export default CoachingSettingsDrawer
